import React, { useEffect, useState } from "react";
import ImageCarousal from "../Components/ImageCarousal";
import { Getdata } from "../helpers/api.service";
import dayjs from "dayjs";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../Components/common/Breadcrums";

const Department = () => {
  const navigate = useNavigate();
  const location = useLocation();
  //   const { title, description } = location.state || {};
  const title = "Departments";
  const description = "School departments collaborate to elevate our students to new levels of achievement. Each department is comprised of educators who specialize in a particular field, thereby strengthening the department, which is reflected in the overall performance of the school."
  //   const {  } = useParams();
  let [data, setData] = useState([]);
  let [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);

  const fetchData = () => {
    setLoading(true);
    Getdata(
      process.env.REACT_APP_URL +
      `/front/${title?.toLowerCase()}/fetch/${process.env.REACT_APP_SUBDOMAIN}`
    )
      .then((res) => {
        console.log("News API response:", res);
        if (res?.data) {
          setData(res.data);
        }
        setImages(res.data.map((item) => item.image));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  console.log(data, "--Harshal");

  return (
    <div className="py-2">
      <div className="text-start max-w-7xl px-4 sm:mx-auto font-medium my-5 mt-8">
        <Breadcrums
          pages={[{ title }]}
        />
      </div>
      <ImageCarousal images={images} title={title} />

      <div className="p-6 space-y-6  text-left">
        <div className="sm:mx-auto max-w-6xl ">
          <h2 className="text-f40 text-black text-center font-bold mb-5">
            {title}
          </h2>
          <p className="text-f15 text-start ">{description}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 max-w-6xl  mx-auto">
          {data?.length > 0 &&
            data?.map((item, index) => (
              <div
                className="bg-[#F9F5FF] border-[#EAEAEA] border-2 rounded-lg "
                key={index}
              >
                <img
                  className="w-full h-[200px] sm:h-[230px] object-cover cursor-pointer"
                  onClick={() =>
                    navigate(`/department-details/${item.title}`, {
                      state: { title: title },
                    })
                  }
                  alt={item.title}
                  src={item.image}
                />
                <div className=" relative flex justify-between text-gray-800 px-4 mb-2 mx-auto">
                  <div>
                    <h3 className="text-sm font-semibold pt-[10px]  ">
                      {item.title}
                    </h3>
                    <p className="pb-2">{item?.detailed}</p>
                    <h3 className="text-sm text-gray-400 font-normal  ">
                      {dayjs(item.createdAt).format("DD MMM YYYY")}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
        </div>
        {data?.length === 0 && (
          <div className="h-[50vh] flex items-center justify-center w-full">
            <h1 className="text-center text-gray-400">No Data Found</h1>
          </div>
        )}
      </div>
    </div>
  );
};

export default Department;
